/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Inline_LabelInputs */



/**
* | output |
* | --- |
* | "Insert Inline" |
*
* @param {Insert_Speaker_Inline_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_inline_label = /** @type {((inputs?: Insert_Speaker_Inline_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Inline_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer en ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Inline einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci in linea")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить встроенный текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar en línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入内联")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インライン挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इनलाइन डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir em linha")
	return /** @type {LocalizedString} */ ("Insert Inline")
});